import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconFailedProps } from './IconFailed.types'
import * as Styled from './styles/IconFailed.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFailed: FC<IconFailedProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFailedProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconFailedProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M20.57 9.836a3.197 3.197 0 0 1-.015 4.523l-.051.051a3.203 3.203 0 0 1-2.274 3.914l-.07.016c-.133.484-.375.93-.707 1.3a3.209 3.209 0 0 1-3.289.93 3.197 3.197 0 0 1-4.523-.015l-.051-.051a3.203 3.203 0 0 1-3.914-2.274.468.468 0 0 0-.016-.07 3.232 3.232 0 0 1-1.3-.707 3.209 3.209 0 0 1-.93-3.289 3.2 3.2 0 0 1 .02-4.523l.05-.051a3.203 3.203 0 0 1 2.273-3.914l.067-.016c.133-.484.375-.93.707-1.3a3.209 3.209 0 0 1 3.289-.93 3.197 3.197 0 0 1 4.523.015l.051.051a3.203 3.203 0 0 1 3.914 2.274c0 .023.008.046.016.07.484.133.93.375 1.3.707a3.209 3.209 0 0 1 .93 3.289Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M18.5 12a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM14 10.031 10.031 14m0-3.969L14 14' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconFailed
